import React, { useState, useContext } from "react";
import { HttpService } from "../../apiAuthorization/httpService";
import { Context } from "../contexts/siteContext";

export const SystemVariable = React.createContext(null);

export const SystemVariableContext = props => {
    const { defaultSite } = useContext(Context);
    const [systemVariables, setSystemVariables] = useState([]);
    const [inactiveTime, setInactiveTime] = useState(0);

    const getSystemVariables = () => {
        HttpService.post('/SystemVariable/GetSystemVariables', {
            SiteId: defaultSite.id
        })
        .then((result) => {
            setSystemVariables(result.data);
            for (let item of result.data) {
                if (item.VariableName === "InactiveTime") {
                    setInactiveTime(parseInt(item.VariableValue, 10));
                    break;
                }
            }
        },
        (error) => {
            console.log(error);
        });
    }

    return (
        <>
            <SystemVariable.Provider value={{ systemVariables, getSystemVariables, inactiveTime }}>
                {props.children}
            </SystemVariable.Provider>
        </>
    );
}
